import * as React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "../../../assets/sass/components/deletePopup.scss";
import { handleEnter, imagePathurl, capitalize } from "../../utils/utils";
import { ACTION_DESCRIPTION } from "./constant";
const Popup: React.FC<any> = (props) => {
    const { onConfirm, onCancel, activeAction } = props;
    //image CDN_PATH
    const getimagePath = imagePathurl();
    const headerTitle =
        activeAction === "delete"
            ? "Are you sure you want to delete this cart?"
            : `${capitalize(activeAction)} Warranty?`;
    const confirmBtn =
        activeAction === "delete" ? `${capitalize(activeAction)} Cart?` : `${capitalize(activeAction)} Warranty?`;
    return (
        <React.Fragment>
            <div className="form-container-block" id="form-container">
                <div className="overlay" onClick={() => onCancel()}>
                    <div
                        className="popup-container"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div
                            id="close_popup"
                            className="close-menu"
                            onClick={() => onCancel()}
                            onKeyPress={handleEnter}
                        >
                            <img className="popup-close-icon" src={`${getimagePath}close-mobile.png`} alt="close" />
                        </div>
                        <div className="popup-header-title">{headerTitle}</div>
                        <div className="popup-header-subtitle">{ACTION_DESCRIPTION[activeAction.toUpperCase()]}</div>
                        <div>
                            <Row className="confirm-cancel-actions">
                                <Col md={6}>
                                    <div className="d-flex">
                                        <Button className="btn gaf-btn-primary cancel-btn" onClick={onCancel}>
                                            Cancel
                                        </Button>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="d-flex justify-content-end">
                                        <Button className="btn gaf-btn-primary confirm-btn" onClick={onConfirm}>
                                            {confirmBtn}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Popup;
